import * as y from "react";
import { i as _, E as m, x as s, a as h, r as v, c as k } from "../createReactComponent-58f9bea8.mjs";
import { n as i } from "../property-9daa16cd.mjs";
import { r as w } from "../state-7560d4dc.mjs";
import { e as $ } from "../query-d94c86d2.mjs";
import { e as u } from "../class-map-2994e95e.mjs";
import { S as W } from "../slot-controller-fa97ce97.mjs";
import { a as T } from "../menu-item-group-76fb1396.mjs";
import { r as z } from "../icon-c572aa57.mjs";
import { r as b } from "../tooltip-cb602d1f.mjs";
import { r as f } from "../icon-button-a9d2a2d1.mjs";
import { r as S } from "../button-7600b6ca.mjs";
import { r as E } from "../textarea-2860ed4a.mjs";
import { r as H } from "../menu-3df3d7c3.mjs";
import { r as A } from "../menu-item-65dd9fa4.mjs";
import "../base-e16d29d8.mjs";
import "../if-defined-47693dfa.mjs";
import "../live-6c85dd15.mjs";
import "../purify.es-39f8036b.mjs";
import "../pill-a1831740.mjs";
import "../pill-group-834f5519.mjs";
import "../utils-cf5bbdd1.mjs";
import "../style-map-c3339321.mjs";
import "../checkbox-46b40c6a.mjs";
import "../radio-8b0e9514.mjs";
const I = _`
  :host {
    --exo-component-wizard-body-padding: var(--exo-spacing-3x-small)
      var(--exo-spacing-x-small);
    --exo-component-wizard-steps-width: 30%;
  }

  :host div {
    display: block;
    height: 100%;
  }

  :host .wizard-vertical {
    display: flex;
    width: 100%;
  }

  :host .wizard__steps {
    width: var(--exo-component-wizard-steps-width);
    display: flex;
    padding: var(--exo-spacing-small);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--exo-spacing-medium);
    overflow-y: auto;
  }

  :host .wizard-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--exo-spacing-standard);
  }

  :host #wizard__item {
    min-height: var(--exo-size-3);
    min-width: var(--exo-size-5);
    flex: 1;
    overflow-y: auto;
    border-radius: var(--exo-radius-small);
    padding: var(--exo-component-wizard-body-padding);
  }

  :host .wizard--container {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex: 1;
    position: relative;
  }

  :host .wizard__title,
  :host .wizard__title.wizard--complete {
    display: flex;
    position: relative;
    width: var(--exo-size-3);
    font: var(--exo-text-label-standard);
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: calc(0.5 * var(--exo-size-1));
    border-radius: calc(2 * var(--exo-radius-small));
    border-left: var(--exo-spacing-3x-small) solid transparent;
  }

  :host .wizard__title:hover,
  :host .wizard__title.wizard--complete:hover {
    background: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-background-background-deselected-hover);
  }

  :host .wizard__title:focus-visible,
  :host .wizard__title.wizard--complete:focus-visible {
    border-radius: calc(2 * var(--exo-radius-small));
    background: var(--exo-color-background-action-hover-weak);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .wizard__title .wizard-content {
    display: flex;
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-x-small);
    align-items: center;
    gap: var(--exo-spacing-x-small);
    align-self: stretch;
    cursor: pointer;
    border-radius: calc(2 * var(--exo-radius-small));
  }

  :host .wizard__title.wizard--incomplete-current,
  :host .wizard__title.wizard--complete-current {
    font: var(--exo-text-label-standard-semi-bold);
    background: var(--exo-color-background-selected-weak);
  }

  :host .wizard__title.wizard--incomplete-current:hover,
  :host .wizard__title.wizard--complete-current:hover {
    border-top-left-radius: var(--exo-spacing-none);
    border-bottom-left-radius: var(--exo-spacing-none);
  }

  :host .wizard__title.wizard--incomplete-current:focus-visible,
  :host .wizard__title.wizard--complete-current:focus-visible {
    border-radius: calc(2 * var(--exo-radius-small));
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .wizard__title.wizard--error:focus-visible {
    border-radius: calc(2 * var(--exo-radius-small));
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .wizard__title.wizard--error-current {
    background: var(--exo-color-background-danger-weak);
    border-left: var(--exo-spacing-3x-small) solid transparent;
    font: var(--exo-text-body-small-semibold);
  }

  :host .wizard__title.wizard--error-current:hover {
    border-top-left-radius: var(--exo-spacing-none);
    border-bottom-left-radius: var(--exo-spacing-none);
  }

  :host .wizard__title.wizard--error-current:focus-visible {
    border-radius: calc(2 * var(--exo-radius-small));
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .wizard__title.wizard--warning:focus-visible {
    border-radius: calc(2 * var(--exo-radius-small));
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-warning-strong);
  }

  :host .wizard__title.wizard--warning-current {
    font: var(--exo-text-label-standard-semi-bold);
    background: var(--exo-color-background-warning);
    border-left: var(--exo-spacing-3x-small) solid transparent;
  }

  :host .wizard__title.wizard--warning-current:hover {
    border-top-left-radius: var(--exo-spacing-none);
    border-bottom-left-radius: var(--exo-spacing-none);
  }

  :host .wizard__title.wizard--warning-current:focus-visible {
    border-radius: calc(2 * var(--exo-radius-small));
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-warning-strong);
  }

  :host([open]) .wizard__content {
    display: block;
    min-height: var(--exo-size-3);
    min-width: var(--exo-size-5);
    color: var(--exo-color-font);
    padding: var(--exo-spacing-x-small);
  }

  :host .wizard-title {
    width: 100%;
    height: auto;
  }

  :host .wizard-index {
    width: var(--exo-spacing-x-large);
    height: var(--exo-spacing-x-large);
    padding: var(--exo-spacing-small);
    border-radius: var(--exo-radius-circle);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-color: var(--exo-color-background);
  }

  :host .wizard__title.wizard--incomplete-current::before,
  :host .wizard__title.wizard--complete-current::before,
  :host .wizard__title.wizard--error-current::before,
  :host .wizard__title.wizard--warning-current::before {
    content: "";
    height: var(--exo-spacing-large);
    border-radius: var(--exo-radius-small);
    background: var(--exo-color-background-selected);
    width: var(--exo-spacing-3x-small);
    position: absolute;
    left: calc(-1 * var(--exo-spacing-3x-small));
    transition: height var(--exo-time-standard) ease;
  }

  :host .wizard__title.wizard--error-current::before {
    background: var(--exo-color-background-danger-strong);
  }

  :host .wizard__title.wizard--warning-current::before {
    background: var(--exo-color-background-warning-strong);
  }

  :host .wizard__title.wizard--incomplete-current:hover::before,
  :host .wizard__title.wizard--complete-current:hover::before,
  :host .wizard__title.wizard--error-current:hover::before,
  :host .wizard__title.wizard--warning-current:hover::before,
  :host .wizard__title.wizard--incomplete-current:focus-visible::before,
  :host .wizard__title.wizard--complete-current:focus-visible::before,
  :host .wizard__title.wizard--error-current:focus-visible::before,
  :host .wizard__title.wizard--warning-current:focus-visible::before {
    height: calc(2 * var(--exo-spacing-medium));
    box-sizing: border-box;
    border-radius: var(--exo-spacing-none);
  }

  :host .wizard--incomplete .wizard-title {
    color: var(--exo-color-font-secondary);
  }

  :host .wizard--incomplete-current .wizard-title,
  :host .wizard--complete-current .wizard-title,
  :host .wizard--incomplete-current .wizard-index,
  :host .wizard--complete-current .wizard-index {
    color: var(--exo-color-background-selected);
  }

  :host .wizard--complete.wizard--complete-current .wizard-index {
    color: var(--exo-color-background-selected);
  }

  :host .wizard--error-current .wizard-title,
  :host .wizard--error-current .wizard-index {
    color: var(--exo-color-background-danger-strong);
  }

  :host .wizard--warning-current .wizard-index {
    color: var(--exo-color-background-warning-strong);
  }

  :host .wizard--complete .wizard-index {
    color: var(--exo-color-background-deselected);
  }

  :host .wizard--error .wizard-index {
    color: var(--exo-color-background-danger-strong);
  }

  :host .wizard--warning .wizard-index {
    color: var(--exo-color-background-warning-strong);
  }

  :host .wizard--incomplete-current .wizard-index,
  :host .wizard--complete-current .wizard-index,
  :host .wizard--error-current .wizard-index,
  :host .wizard--warning-current .wizard-index {
    background: var(--exo-color-background);
  }

  :host .stepper {
    margin-bottom: var(--exo-spacing-large);
  }

  :host .wizard-item-icon {
    font-size: var(--exo-spacing-large);
  }

  :host .wizard-item-icon.wizard-item-icon--complete {
    color: var(--exo-color-font-success);
  }

  :host .wizard--footer {
    height: calc(0.6 * var(--exo-size-1));
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--exo-spacing-x-small) var(--exo-spacing-medium);
  }

  :host .wizard--footer.hide {
    display: none;
  }

  /* css for wizard horizontal */

  :host .wizard--container-horizontal {
    padding: var(--exo-spacing-3x-small) var(--exo-spacing-x-small);
  }

  :host .header-horizontal {
    display: flex;
    padding: var(--exo-spacing-3x-small) var(--exo-spacing-none);
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: var(--exo-spacing-2x-small);
    align-self: stretch;
  }

  :host .header-stepper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: var(--exo-spacing-2x-small);
    align-self: stretch;
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font-secondary);
  }

  :host .header-horizontal .header-title {
    align-self: stretch;
    display: flex;
    justify-content: center;
    color: var(--exo-color-background-selected);
    font: var(--exo-text-label-medium-semi-bold);
  }

  :host .stepper-horizontal {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: var(--exo-spacing-standard);
    gap: var(--exo-spacing-3x-small);
  }

  :host .rail-between {
    display: flex;
    width: var(--exo-spacing-x-large);
    height: var(--exo-spacing-large);
    padding: calc(var(--exo-spacing-3x-small) + var(--exo-spacing-x-small))
      var(--exo-spacing-3x-small);
    align-items: center;
    gap: calc(var(--exo-spacing-3x-small) + var(--exo-spacing-x-small));
    box-sizing: border-box;
  }

  :host .wizard-dot,
  :host .wizard-dot--incomplete,
  :host .wizard-dot--complete {
    width: var(--exo-spacing-large);
    height: var(--exo-spacing-large);
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-radius: calc(2 * var(--exo-radius-small));
    border: var(--exo-spacing-3x-small) solid transparent;
    color: var(--exo-color-background-deselected);
    outline: none;
    box-sizing: border-box;
    cursor: pointer;
  }

  :host .wizard-dot--incomplete:hover,
  :host .wizard-dot--complete:hover {
    border-radius: var(--exo-spacing-standard);
    background: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-background-deselected-hover);
  }

  :host .wizard-dot--incomplete:focus-visible,
  :host .wizard-dot--complete:focus-visible {
    border: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
    border-radius: calc(2 * var(--exo-radius-small));
    color: var(--exo-color-background-deselected-hover);
  }

  :host .wizard-dot--incomplete-current,
  :host .wizard-dot--complete-current {
    color: var(--exo-color-background-selected);
    border-radius: var(--exo-spacing-standard);
    background: var(--exo-color-background-selected-weak);
  }

  :host .wizard-dot--incomplete-current:hover,
  :host .wizard-dot--complete-current:hover {
    color: var(--exo-color-background-selected-hover);
    background: var(--exo-color-background-selected-weak);
  }

  :host .wizard-dot--incomplete-current:focus-visible,
  :host .wizard-dot--complete-current:focus-visible {
    color: var(--exo-color-background-selected-hover);
    border-radius: calc(2 * var(--exo-radius-small));
    border-color: var(--exo-color-background-selected);
  }

  :host .wizard-dot--error {
    color: var(--exo-color-background-danger-strong);
  }

  :host .wizard-dot--error:hover {
    border-radius: var(--exo-spacing-standard);
    background: var(--exo-color-background-action-hover-weak);
  }

  :host .wizard-dot--error:focus-visible {
    border: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
    border-radius: calc(2 * var(--exo-radius-small));
  }

  :host .wizard-dot--error-current {
    border-radius: var(--exo-spacing-standard);
    background: var(--exo-color-background-danger-weak);
  }

  :host .wizard-dot--error-current:hover {
    color: var(--exo-color-background-danger-strong-hover);
    background: var(--exo-color-background-danger-weak);
  }

  :host .wizard-dot--error-current:focus-visible {
    color: var(--exo-color-background-danger-strong-hover);
    border-radius: calc(2 * var(--exo-radius-small));
    border-color: var(--exo-color-background-danger-strong);
  }

  :host .wizard-dot--warning {
    color: var(--exo-color-background-warning-strong);
  }

  :host .wizard-dot--warning:hover {
    border-radius: var(--exo-spacing-standard);
    background: var(--exo-color-background-action-hover-weak);
  }

  :host .wizard-dot--warning:focus-visible {
    border: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-warning-strong);
    border-radius: calc(2 * var(--exo-radius-small));
  }

  :host .wizard-dot--warning-current,
  :host .wizard-dot--warning-current:hover {
    border-radius: var(--exo-spacing-standard);
    background: var(--exo-color-background-warning);
  }

  :host .wizard-dot--warning-current:focus-visible {
    color: var(--exo-color-background-warning-strong);
    border-radius: calc(2 * var(--exo-radius-small));
    border-color: var(--exo-color-background-warning-strong);
  }

  :host .wizard__steps.divider {
    border-right: 1px solid var(--exo-color-border-secondary);
    height: auto;
  }
`, j = _`
  :host .copy {
    display: flex;
    justify-content: space-between;
  }

  :host .icon-button-wrapper {
    font-size: var(--exo-font-size-x-large);
  }
`;
var D = Object.defineProperty, O = Object.getOwnPropertyDescriptor, x = (t, e, r, o) => {
  for (var c, a = o > 1 ? void 0 : o ? O(e, r) : e, l = t.length - 1; l >= 0; l--)
    (c = t[l]) && (a = (o ? c(e, r, a) : c(a)) || a);
  return o && a && D(e, r, a), a;
};
class p extends m {
  constructor() {
    super(...arguments), this.text = "", this.animatedText = "copy", this.position = "right", this.hideText = !1, this.flavor = "branded", this.type = "tertiary", this.size = "small", this.iconlabel = "", this.copy = () => {
      navigator.clipboard.writeText(this.text).then(() => {
        this.animatedText = "copied", setTimeout(() => {
          this.animatedText = "copy";
        }, 2e3);
      });
    };
  }
  getText() {
    return this.hideText ? h : s`<div class="input">${this.text}</div>`;
  }
  render() {
    return s` <div class="copy">
      <div class="text">${this.getText()}</div>
      <div class="icon-button-wrapper" @click=${this.copy}>
        <ex-tooltip position=${this.position} alignment="middle">
          <div>${this.animatedText}</div>
          <ex-icon-button
            slot="anchor"
            icon="copy"
            flavor=${this.flavor}
            type=${this.type}
            size=${this.size}
            label=${this.iconlabel}
          >
          </ex-icon-button
        ></ex-tooltip>
      </div>
    </div>`;
  }
}
p.styles = j, x([i()], p.prototype, "text", 2), x([w()], p.prototype, "animatedText", 2), x([i()], p.prototype, "position", 2), x([i({ type: Boolean, attribute: "hide-text" })], p.prototype, "hideText", 2), x([i()], p.prototype, "flavor", 2), x([i()], p.prototype, "type", 2), x([i()], p.prototype, "size", 2), x([i({ type: String })], p.prototype, "iconlabel", 2);
var V = Object.defineProperty, N = Object.getOwnPropertyDescriptor, d = (t, e, r, o) => {
  for (var c, a = o > 1 ? void 0 : o ? N(e, r) : e, l = t.length - 1; l >= 0; l--)
    (c = t[l]) && (a = (o ? c(e, r, a) : c(a)) || a);
  return o && a && V(e, r, a), a;
}, B = ((t) => (t.INCOMPLETE = "Incomplete", t.COMPLETE = "Complete", t.ERROR = "Error", t.WARNING = "Warning", t))(B || {}), M = ((t) => (t.VERTICAL = "Vertical", t.HORIZONTAL = "Horizontal", t))(M || {});
class g extends m {
  constructor() {
    super(...arguments), this.open = !1, this.title = "", this.step = "Incomplete", this.description = "", this.show = !0;
  }
  render() {
    return this.show ? s`
          <div class="wizard-item">
            <div class="wizard__content" role="region">
              <slot></slot>
            </div>
          </div>
        ` : h;
  }
}
g.styles = I, d([i({ type: Boolean, reflect: !0 })], g.prototype, "open", 2), d([i({ type: String })], g.prototype, "title", 2), d([i()], g.prototype, "step", 2), d([i({ type: String })], g.prototype, "description", 2), d([i({ type: Boolean, reflect: !0 })], g.prototype, "show", 2);
class n extends m {
  constructor() {
    super(...arguments), this.selectedIndex = -1, this.totalItems = 0, this.allowMultiple = !1, this.headerDescription = "Description", this.wizardTitle = "Wizard Title", this.headerTitle = "Step Title", this.type = "Vertical", this.step = "Incomplete", this.tooltipText = "Action", this.hideActions = !1, this.stylable = !1, this.divider = !1, this.slotController = new W(this, "footer");
  }
  getStatusIcon(e) {
    return s`<ex-icon
      hide-browser-tooltip=""
      size=${this.type === "Vertical" ? "S" : "XS"}
      icon="${e}"
      part="index"
    ></ex-icon>`;
  }
  getIcon(e) {
    switch (e) {
      case "Complete":
        return this.getStatusIcon("Success");
      case "Error":
        return this.getStatusIcon("Error");
      case "Warning":
        return this.getStatusIcon("Start");
      default:
        return this.getStatusIcon("planned");
    }
  }
  setHeaderAndDescriptionContent() {
    var e;
    (e = this.wizardItems) != null && e.length ? (this.selectedIndex = this.wizardItems.findIndex((r) => r.open) || 0, this.wizardItems[this.selectedIndex] && (this.headerTitle = this.wizardItems[this.selectedIndex].title, this.headerDescription = this.wizardItems[this.selectedIndex].description)) : this.selectedIndex = 0;
  }
  setWizardItemContent() {
    var e;
    if ((e = this.wizardItems) != null && e.length && this.wizardItemContainer)
      if (this.stylable)
        this.wizardItems.forEach((r, o) => {
          r.show = o === this.selectedIndex;
        });
      else {
        let r;
        this.selectedIndex !== -1 ? r = this.wizardItems[this.selectedIndex] : [r] = this.wizardItems, this.wizardItemContainer.replaceChildren(), this.wizardItemContainer.appendChild(r);
      }
  }
  renderWizardHeaderMobile() {
    var e;
    return (e = this.wizardItems) != null && e.length ? s`<ex-icon-button
          icon="direction-arrow-left"
          flavor="branded"
          type="tertiary"
        ></ex-icon-button>
        <div class="wizard__mobile-title">${this.wizardTitle}</div>
        <ex-icon-button
          icon="Close"
          flavor="branded"
          type="tertiary"
        ></ex-icon-button> ` : h;
  }
  renderWizardHeader() {
    var e;
    return (e = this.wizardItems) != null && e.length ? s`<div class="header-title">${this.headerTitle}</div>
        <div class="header-description">${this.headerDescription}</div>` : h;
  }
  update(e) {
    super.update(e), this.hasUpdated && (this.setHeaderAndDescriptionContent(), this.setWizardItemContent());
  }
  firstUpdated() {
    this.wizardItems = Array.from(this.querySelectorAll("ex-wizard-item")), this.setHeaderAndDescriptionContent(), this.setWizardItemContent();
  }
  onWizardItemClickHandler(e) {
    this.wizardItems.forEach((r) => {
      this.stylable && (r.show = !1), r.removeAttribute("open");
    }), e.show = !0, e.setAttribute("open", "true"), this.setHeaderAndDescriptionContent(), this.setWizardItemContent(), this.dispatchCustomEvent("onSelect", { selectedIndex: this.selectedIndex, title: this.headerTitle, step: e.step });
  }
  onWizardItemKeyHandler(e, r) {
    r.code !== "Enter" && r.code !== "Space" || (r.preventDefault(), r.currentTarget && this.onWizardItemClickHandler(e));
  }
  renderCopyAndIconButton(e) {
    return s`
      <ex-copy
        class="copy-text"
        hide-text
        text=${e.title}
        position="top"
        type="tertiary"
        size="small"
      ></ex-copy>
      <ex-icon-button
        icon="More options"
        flavor="branded"
        type="tertiary"
        showtooltip=""
        tooltiptext=${this.tooltipText}
        size="small"
      ></ex-icon-button>
    `;
  }
  renderVerticalItemStep(e, r) {
    return s`<div
      class=${u({ wizard__title: !0, "wizard--incomplete": e.step === "Incomplete", "wizard--incomplete-current": e.step === "Incomplete" && this.selectedIndex === r, "wizard--complete": e.step === "Complete", "wizard--complete-current": e.step === "Complete" && this.selectedIndex === r, "wizard--error": e.step === "Error", "wizard--error-current": e.step === "Error" && this.selectedIndex === r, "wizard--warning": e.step === "Warning", "wizard--warning-current": e.step === "Warning" && this.selectedIndex === r })}
      tabindex="0"
      aria-controls="wizard__item"
      @click="${this.onWizardItemClickHandler.bind(this, e)}"
      @keypress="${this.onWizardItemKeyHandler.bind(this, e)}"
    >
      <div class="wizard-content">
        <span class="wizard-index" part="index"
          >${e.step === "Incomplete" ? r + 1 : this.getIcon(e.step)}</span
        >
        <div class="wizard-title">${e.title}</div>
        ${this.hideActions ? h : this.renderCopyAndIconButton(e)}
      </div>
    </div>`;
  }
  renderWizardVertical() {
    var e;
    return (e = this.wizardItems) != null && e.length ? this.wizardItems.map((r, o) => this.renderVerticalItemStep(r, o)) : h;
  }
  renderHorizontalItemStep(e, r) {
    const o = this.wizardItems[r], c = s`<ex-icon
      hide-browser-tooltip=""
      icon="Selected"
    ></ex-icon>`, a = s`<div class="rail-between">
      <ex-icon size="M" icon="Rail" hide-browser-tooltip="" variant="icon" />
    </div>`;
    return s`
      <ex-tooltip tooltipdelay="0" position="top" alignment="middle">
        <div>${o.title}</div>
        <div
          class=${u({ "wizard-dot": !0, "wizard-dot--incomplete": o.step === "Incomplete", "wizard-dot--incomplete-current": o.step === "Incomplete" && this.selectedIndex === r, "wizard-dot--complete": o.step === "Complete", "wizard-dot--complete-current": o.step === "Complete" && this.selectedIndex === r, "wizard-dot--error": o.step === "Error", "wizard-dot--error-current": o.step === "Error" && this.selectedIndex === r, "wizard-dot--warning": o.step === "Warning", "wizard-dot--warning-current": o.step === "Warning" && this.selectedIndex === r })}
          slot="anchor"
          aria-controls="wizard__item"
          tabindex="0"
          @click=${() => {
      this.selectedIndex = r, this.onWizardItemClickHandler(o);
    }}
          @keypress=${(l) => {
      l.code !== "Enter" && l.code !== "Space" || (l.preventDefault(), this.selectedIndex = r, this.onWizardItemClickHandler(o));
    }}
        >
          ${o.step === "Incomplete" && this.selectedIndex === r ? c : this.getIcon(o.step)}
        </div>
      </ex-tooltip>
      ${r < e - 1 ? a : h}
    `;
  }
  renderWizardHorizontal() {
    var e;
    if ((e = this.wizardItems) != null && e.length) {
      const r = this.wizardItems ? this.wizardItems.length : 0, o = Array.from({ length: r }, (c, a) => this.renderHorizontalItemStep(r, a));
      return s`
          <div class="header-horizontal">
            <div class="header-stepper">
              Step ${this.selectedIndex + 1} out of ${r}
            </div>
            <div class="header-title">${this.headerTitle}</div>
          </div>
          <div class="stepper-horizontal">${o}</div>
        </div>
      `;
    }
    return h;
  }
  renderWizardContent() {
    var e;
    return (e = this.wizardItems) != null && e.length ? s`
        <div
          class="wizard__content-item"
          id="wizard__item"
          role="region"
          aria-labelledby="wizard__title"
        >
          <slot></slot>
        </div>
      ` : h;
  }
  getFooter() {
    const e = { "wizard--footer": !0, hide: !this.slotController.test("footer") };
    return s`
      ${this.stylable ? this.renderWizardContent() : s`<div id="wizard__item"></div>`}
      <div class=${u(e)}>
        <slot class="wizard--footer-slot" name="footer"></slot>
      </div>
    `;
  }
  getVerticalType() {
    return s`
      <div class="wizard-vertical">
        <div
          class=${u({ wizard__steps: !0, divider: this.divider })}
          part="wizard__steps"
        >
          <div class="wizard-header">${this.renderWizardVertical()}</div>
        </div>
        <div class="wizard--container">${this.getFooter()}</div>
      </div>
    `;
  }
  getHorizontalType() {
    return s`
      <div class="wizard-horizontal">
        <div class="wizard-horizontal--container">
          ${this.renderWizardHorizontal()}
          <div class="wizard--container-horizontal">${this.getFooter()}</div>
          <div></div>
        </div>
      </div>
    `;
  }
  renderWizard(e) {
    switch (e) {
      case "Vertical":
      default:
        return this.getVerticalType();
      case "Horizontal":
        return this.getHorizontalType();
    }
  }
  render() {
    return s` <div class="wizard">${this.renderWizard(this.type)}</div>`;
  }
}
n.styles = I, d([i({ type: Number })], n.prototype, "selectedIndex", 2), d([i({ type: Number })], n.prototype, "totalItems", 2), d([i({ type: Boolean, reflect: !0, attribute: "allow-multiple" })], n.prototype, "allowMultiple", 2), d([$("#wizard__item")], n.prototype, "wizardItemContainer", 2), d([w()], n.prototype, "headerDescription", 2), d([i()], n.prototype, "wizardTitle", 2), d([w()], n.prototype, "headerTitle", 2), d([i()], n.prototype, "type", 2), d([i()], n.prototype, "step", 2), d([i()], n.prototype, "tooltipText", 2), d([i({ type: Boolean })], n.prototype, "hideActions", 2), d([i({ type: Boolean })], n.prototype, "stylable", 2), d([i({ type: Boolean })], n.prototype, "divider", 2);
const C = (t = "") => {
  v("ex-wizard-item", g, t), v("ex-wizard", n, t), T(t), z(t), ((e = "") => {
    v("ex-copy", p, e), z(e), b(e), f(e);
  })(t), S(t), E(t), H(t), A(t), b(t), f(t);
}, pe = k({ tagName: "ex-wizard", elementClass: n, react: y, events: { onSelect: "onSelect" }, displayName: "ExWizard", registerWebComponent: C }), he = k({ tagName: "ex-wizard-item", elementClass: g, react: y, events: {}, displayName: "ExWizardItem", registerWebComponent: C });
export {
  pe as ExWizard,
  he as ExWizardItem,
  n as Wizard,
  g as WizardItem,
  B as WizardStep,
  M as WizardType,
  C as register
};
